/**
 * =====================================
 * File: Login.js
 * Page: /login
 * Purpose: Creates the login page that allows registered
 *  users to access their account
 * Author: Noah Fultz
 * Date: 2026-06-15
 * =====================================
 */

import './Login.css';

import { PageCard } from '../../components';


function LoginPage() {
	return (
		<PageCard header='Login coming soon...'>
			<p className='login-info-text'>
				Due to some issues with the infrastructure of the site, we are migrating to
				a new platform. Some of the pages are not quite finished yet, but you'll be
				able to log back into your original account and see the calendar and photos
				soon. Thank you for your patience!
			</p>
		</PageCard>
	)
}


export default LoginPage;